/**
 * Payload for saving a vendor from the agent form.
 * Identity and timestamp columns stay on the existing row.
 * A team vendor must carry this profile's team_id. The update policy
 * "Agents can update own vendors" rejects visibility "team" when team_id
 * is null. An agent with no team can only save a personal vendor.
 */

const OMITTED_ON_UPDATE = [
  'id',
  'agent_id',
  'created_by',
  'created_at',
  'updated_at',
  'date_added',
];

function buildVendorUpdateData(formData, profile) {
  const source = formData && typeof formData === 'object' ? formData : {};
  const updateData = {};
  Object.keys(source).forEach((key) => {
    if (OMITTED_ON_UPDATE.indexOf(key) === -1) updateData[key] = source[key];
  });

  const hasTeam = Boolean(profile && profile.team_id);
  const visibility = hasTeam && source.visibility === 'team' ? 'team' : 'personal';
  updateData.visibility = visibility;
  updateData.team_id = visibility === 'team' ? profile.team_id : null;

  if (Array.isArray(source.categories)) {
    updateData.categories = source.categories;
    updateData.category = source.categories[0];
  }

  return updateData;
}

module.exports = {
  OMITTED_ON_UPDATE,
  buildVendorUpdateData,
};
